// extracted by mini-css-extract-plugin
export default {"input":"input--nbE4e","color":"color--oUitc","ul":"ul--JWKFl","li":"li--jh2Qe"};